<template>
    <div class="sector-edit__wrapper">
        <ValidationAlert :error-list="errors.collect('server')"></ValidationAlert>
        <ValidationAlert :error-list="errors.collect('event')"></ValidationAlert>
        <form class="form" @submit.prevent="submit" novalidate>
            <modal
                name="warning"
                height="auto"
                :adaptive="true"
                :width="450"
            >
                <div class="modal__title">
                    <span class="h2">{{ modal.title }}</span>
                </div>
                <div class="modal__copy">
                    <p>{{ modal.copy }}</p>
                </div>
                <div class="modal__buttons">
                    <button type="button" class="btn btn-outline-primary" @click="hide">
                        I understand
                    </button>
                </div>
            </modal>
            <fieldset class="form__group">
                <div class="sector-edit__new">
                    <div class="form__group">
                        <input id="name" name="name" v-model="formData.name" @input="slugify_field(formData.name)"
                               placeholder="Enter a title" required
                               :class="{ 'form__control': true, 'form__control--invalid': errors.first('name') }"
                        />
                        <label for="name" class="form__label">Name</label>
                        <div class="form__validation">{{ errors.first('name') }}</div>
                    </div>
                    <FormControlMember
                        label="Select a Company"
                        placeholder="Select the company that the user works for..."
                        v-model="formData.member"
                        name="member"
                    />
                    <FileUpload
                        id="document"
                        label="Drag and drop document here (.xlsx only)"
                        name="document"
                        v-model="formData.document"
                        file-types="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        :multiple="false"
                        ref="document"
                    />

                    <div class="form__group form__group--submit">
                        <button :disabled="!formValid" class="btn btn--primary">Save &amp; Continue</button>
                    </div>
                </div>
            </fieldset>
        </form>
    </div>
</template>

<script>
    import FormControlMember from '@components/Form/Control/FormControlMember';
    import FileUpload from '@components/Form/FileUpload';
    import ValidationAlert from '@components/ValidationAlert';
    import Form from '@components/Form/Form';
    import API from '@api';

    export default {
        name: "DocumentForm",
        mixins: [ Form, ValidationAlert ],
        components: {
            FormControlMember,
            ValidationAlert,
            FileUpload
        },
        props: {
            event_id: {
                type: Number,
                required: true,
                defaults: 1,
            },
            id: {
                type: Number,
                required: false,
                defaults: null,
            }
        },
        computed: {
            formValid: function() {
                return this.formData.name !== null
                    && this.formData.document !== null
                    && this.formData.member !== null
                    && this.formData.event !== null;
            }
        },
        methods: {
            fetchResource(_) {
                return API.getDocument(this.event_id, this.id)
            },
            sanitizeResource(data) {
                this.formData.id = data.id;
                this.formData.name = data.name;
                this.formData.member = data.member_id;
                this.formData.document = data.attachment.raw.uuid;
                this.formData.event = data.event_id;
                this.event_id = data.event_id;
            },
            load() {

            },
            redirect(id) {
                this.$router.push({
                    name: 'preview-conference-document',
                    params: {
                        document_id: id,
                        event_id: this.event_id,
                    }
                });
            },
            submit(e) {
                console.log("Submitting: ", e)
                if (this.id) {
                    API.editDocument(this.formData, this.id)
                        .then((res) => {
                            console.log("Received response: ", res);
                            this.redirect(res.id);
                        })
                        .catch(error => {
                            API.mapServerValidation(error.response, this.$validator)
                        })
                } else {
                    API.createDocument(this.formData).then((res) => {
                        console.log("Received response: ", res);
                        this.redirect(res.id);
                    })
                    .catch(error => {
                        API.mapServerValidation(error.response, this.$validator)
                    });
                }
            },
            show () {
                this.$modal.show('warning');
            },
            hide () {
                this.$modal.hide('warning');
            }
        },
        watch: {
            'formData.member': async function(val) {
                const { exists, document } = await API.getDocumentForMember(this.formData.member, this.formData.event);
                if(exists && document) {
                    this.modal.show = true;
                    const { member_id: memberId, member: memberName, name: documentName, attachment: { raw: { uuid } }, id: documentId } = document;
                    this.formData.id = documentId;
                    this.formData.name = documentName;
                    this.formData.member = memberId;
                    this.formData.document = uuid;
                    this.modal.show = true;
                    this.modal.title = `An existing document for ${memberName} was found`;
                    this.modal.copy = `The current document will be overwritten when you save.`
                    this.show();
                }
            }
        },
        data() {
            return {
                formData: {
                    id: null,
                    name: null,
                    document: null,
                    member: null,
                    event: this.event_id || 1,
                },
                modal: {
                    show: false,
                    title: "Document for member already exists",
                    copy: "A document for the member already exists."
                }
            }
        },
    }
</script>

<style scoped lang="scss">
    @import '~reflex-grid/scss/includes/variables';
    @import '~reflex-grid/scss/includes/mixins';
    @import '~@/theme/variables';
    @import '~@/mixins/class';
    @import '~@/theme/extenables';
</style>
